<template>
  <base-survey :step="step" :question="question" :optionName="optionName" :setMethodName="setMethodName" :valueName="valueName" :height="height">
  </base-survey>
</template>

<script>
  export default {
    data() {
      return {
        question: "全体的な印象はどうしたいですか？",
        step: 2,
        setMethodName: "setImage",
        optionName: "survey_images",
        valueName: "image",
        height: "100px"
      };
    }
  };
</script>
